import { ServiceOffering } from '@app/shared/types/service-offering';
import { PortalCommunicationOperator } from '@app/shared/utils/communication-operator.util';
import {
  shuffle,
  sortBySpeedThenEffectivePriceThenRandomize,
} from '../util/shared-service-filters.util';

export type ServiceSortingOption =
  | (typeof sortingOptionsFi)[number]
  | (typeof sortingOptionsSv)[number]
  | typeof selectedOffersPlaceholderText;

export type ServiceSortingOptions =
  | typeof sortingOptionsSv
  | typeof sortingOptionsFi;

export const sortingOptionsFi = [
  'ALL_OFFERS',
  'LOWEST_PRICE_BUNDLE',
  'INTERNET_AND_TV_BUNDLE',
  'SPEED_5000',
  'SPEED_2500',
  'SPEED_1000',
  'SPEED_500',
  'SPEED_UP_TO_250',
  'ONLY_TV',
] as const;

export const sortingOptionsSv = [
  'ALL_OFFERS',
  'UNIQUE_OFFERS',
  'INTERNET_AND_TV_BUNDLE',
  'INTERNET_AND_PHONE_BUNDLE',
  'SPEED_1000',
  'SPEED_500',
  'SPEED_250',
  'SPEED_100',
  'SPEED_SLOW',
  'ONLY_TV',
  'ONLY_PHONE',
  'ADDITIONAL_SERVICES',
] as const;

export const selectedOffersPlaceholderText = 'SELECTED_OFFERS_PLACEHOLDER';
export const uniqueOffersSortingOption = 'UNIQUE_OFFERS';

export const StaticIspUrlKeys = {
  ALL: 'all',
  SHUFFLED: 'shuffled',
} as const;

export type PortalConfig = {
  defaultSorting: ServiceSortingOption;
  defaultIsp: string;
  showPlaceholderSorting: boolean;
  showPlaceholderIsp: boolean;
  sortFn: (services: ServiceOffering[]) => ServiceOffering[];
};

/* Default sorting/filtering based on portal */
export const portalConfig: Record<PortalCommunicationOperator, PortalConfig> = {
  [PortalCommunicationOperator.GlobalConnectSe]: {
    defaultSorting: selectedOffersPlaceholderText,
    defaultIsp: StaticIspUrlKeys.SHUFFLED,
    showPlaceholderSorting: true,
    showPlaceholderIsp: true,
    sortFn: shuffle,
  },
  [PortalCommunicationOperator.GlobalConnectFi]: {
    defaultSorting: 'ALL_OFFERS',
    defaultIsp: StaticIspUrlKeys.ALL,
    showPlaceholderSorting: false,
    showPlaceholderIsp: false,
    sortFn: (services) =>
      [...services].sort(sortBySpeedThenEffectivePriceThenRandomize),
  },
};
